<template>
    <div class="share-icons">
        <a
            :style="`background-image: url('${ require('@/assets/images/facebook-icon.png') }')`"
            class='share-icons__link'
            :href="`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`" target="_blank"
        ></a>
        <a
            :style="`background-image: url('${ require('@/assets/images/twitter-icon.png') }')`"
            class='share-icons__link'
            :href="`https://twitter.com/intent/tweet?url=${url}&text=${text}`" target="_blank"
        ></a>
        <a
            :style="`background-image: url('${ require('@/assets/images/whats-icon.png') }')`"
            class='share-icons__link'
            :href="`https://api.whatsapp.com/send?text=${text} ${url}`" target="_blank"
        ></a>
    </div>
</template>

<script>
export default {
    props: ['text'],
    data () {
        return { url: window.location.origin }
    }
};
</script>

<style lang="scss" scoped>
    .share-icons{
      display: grid;
      grid-template-columns: repeat(3, 24px);
      grid-gap: 16px;

        &__link {
          background-repeat: no-repeat;
          background-size: contain;
          width: 24px;
          height: 24px;
        }

    }
</style>
